import {
  BRANCH_GROUP_LAYER_SPACING,
  LAYER_SPACING,
  NODE_NODE_SPACING,
} from "./diagramConfig";

export { NODE_DEFAULT_WIDTH } from "./diagramConfig";

export type ElkDirection = "DOWN" | "RIGHT";

export function buildElkLayoutOptions(direction: ElkDirection = "DOWN") {
  return {
    "elk.algorithm": "layered",
    "elk.direction": direction,
    "elk.hierarchyHandling": "INCLUDE_CHILDREN",
    "elk.layered.spacing.nodeNodeBetweenLayers": String(LAYER_SPACING),
    "elk.spacing.nodeNode": String(NODE_NODE_SPACING),
    "elk.spacing.edgeNode": "30",
    "elk.spacing.edgeEdge": "20",
    "elk.layered.nodePlacement.strategy": "BRANDES_KOEPF",
    "elk.layered.nodePlacement.bk.fixedAlignment": "BALANCED",
    "elk.layered.crossingMinimization.strategy": "LAYER_SWEEP",
    "elk.layered.layering.strategy": "NETWORK_SIMPLEX",
    "elk.padding": "[top=20,left=20,bottom=20,right=20]",
  };
}

export const elkGroupLayoutOptions = {
  "elk.algorithm": "layered",
  "elk.direction": "DOWN",
  "elk.padding": "[top=44,left=16,bottom=16,right=16]",
  "elk.spacing.nodeNode": "24",
  "elk.layered.spacing.nodeNodeBetweenLayers": String(
    BRANCH_GROUP_LAYER_SPACING,
  ),
} as const;
